<template>
  <div v-if="this.getdoctortype">
    <!-- ======= Hero Section ======= -->
    <section id="hero" class="d-flex align-items-center">
      <div class="container">
        <h1>Welcome to Ekhoni Daktar</h1>
        <a href="#about" class="btn-get-started scrollto">Get Started</a>
      </div>
    </section>
    <!-- End Hero -->

    <main id="main">

      <!-- ======= Why Us Section ======= -->
      <section id="why-us" class="why-us">
        <div class="container">

          <div class="row">
            <div class="col-lg-4 d-flex align-items-stretch">
              <div class="content">
                <h3>Why Ekhoni Daktar?</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                  dolore magna aliqua. Duis aute irure dolor in reprehenderit
                  Asperiores dolores sed et. Tenetur quia eos. Autem tempore quibusdam vel necessitatibus optio ad
                  corporis.
                </p>
                <div class="text-center">
                  <a href="#" class="more-btn">Learn More <i class="bx bx-chevron-right"></i></a>
                </div>
              </div>
            </div>
            <div class="col-lg-8 d-flex align-items-stretch">
              <div class="icon-boxes d-flex flex-column justify-content-center">
                <div class="row">
                  <div class="col-xl-4 d-flex align-items-stretch">
                    <div class="icon-box mt-4 mt-xl-0">
                      <i class="bx bx-receipt"></i>
                      <h4>Point One</h4>
                      <p>Consequuntur sunt aut quasi enim aliquam quae harum pariatur laboris nisi ut aliquip</p>
                    </div>
                  </div>
                  <div class="col-xl-4 d-flex align-items-stretch">
                    <div class="icon-box mt-4 mt-xl-0">
                      <i class="bx bx-cube-alt"></i>
                      <h4>Point Two</h4>
                      <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt</p>
                    </div>
                  </div>
                  <div class="col-xl-4 d-flex align-items-stretch">
                    <div class="icon-box mt-4 mt-xl-0">
                      <i class="bx bx-images"></i>
                      <h4>Point Three</h4>
                      <p>Aut suscipit aut cum nemo deleniti aut omnis. Doloribus ut maiores omnis facere</p>
                    </div>
                  </div>
                </div>
              </div><!-- End .content-->
            </div>
          </div>

        </div>
      </section><!-- End Why Us Section -->

<!--      &lt;!&ndash; ======= About Section ======= &ndash;&gt;-->
<!--      <section id="about" class="about">-->
<!--        <div class="container-fluid">-->

<!--          <div class="row">-->
<!--            <div class="col-xl-5 col-lg-6 video-box d-flex justify-content-center align-items-stretch" >-->
<!--              <a href="https://youtu.be/rDYdeq3JW_E" class="venobox play-btn mb-4" data-vbtype="video"-->
<!--                 data-autoplay="true"></a>-->
<!--            </div>-->

<!--            <div-->
<!--                class="col-xl-7 col-lg-6 icon-boxes d-flex flex-column align-items-stretch justify-content-center py-5 px-lg-5">-->
<!--              <h3>About Ekhoni Daktar</h3>-->
<!--              <p>Esse voluptas cumque vel exercitationem. Reiciendis est hic accusamus. Non ipsam et sed minima-->
<!--                temporibus-->
<!--                laudantium. Soluta voluptate sed facere corporis dolores excepturi. Libero laboriosam sint et id nulla-->
<!--                tenetur. Suscipit aut voluptate.</p>-->

<!--              <div class="icon-box">-->
<!--                <div class="icon"><i class="bx bx-fingerprint"></i></div>-->
<!--                <h4 class="title"><a href="">Sub Heading One</a></h4>-->
<!--                <p class="description">Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint-->
<!--                  occaecati cupiditate non provident</p>-->
<!--              </div>-->

<!--              <div class="icon-box">-->
<!--                <div class="icon"><i class="bx bx-gift"></i></div>-->
<!--                <h4 class="title"><a href="">Sub Heading Two</a></h4>-->
<!--                <p class="description">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis-->
<!--                  praesentium voluptatum deleniti atque</p>-->
<!--              </div>-->

<!--              <div class="icon-box">-->
<!--                <div class="icon"><i class="bx bx-atom"></i></div>-->
<!--                <h4 class="title"><a href="">Sub Heading Three</a></h4>-->
<!--                <p class="description">Explicabo est voluptatum asperiores consequatur magnam. Et veritatis odit. Sunt-->
<!--                  aut-->
<!--                  deserunt minus aut eligendi omnis</p>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->

<!--        </div>-->
<!--      </section>&lt;!&ndash; End About Section &ndash;&gt;-->

<!--      &lt;!&ndash; ======= Counts Section ======= &ndash;&gt;-->
<!--      <section id="counts" class="counts">-->
<!--        <div class="container">-->
<!--          <div class="section-title">-->
<!--            <h2>Our Statistics</h2>-->
<!--          </div>-->

<!--          <div class="row">-->

<!--            <div class="col-lg-3 col-md-6">-->
<!--              <div class="count-box">-->
<!--                <i class="icofont-doctor-alt"></i>-->
<!--                <span data-toggle="counter-up">85</span>-->
<!--                <p>Doctors</p>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="col-lg-3 col-md-6 mt-5 mt-md-0">-->
<!--              <div class="count-box">-->
<!--                <i class="icofont-patient-bed"></i>-->
<!--                <span data-toggle="counter-up">18</span>-->
<!--                <p>Departments</p>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="col-lg-3 col-md-6 mt-5 mt-lg-0">-->
<!--              <div class="count-box">-->
<!--                <i class="icofont-laboratory"></i>-->
<!--                <span data-toggle="counter-up">8</span>-->
<!--                <p>Research Labs</p>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="col-lg-3 col-md-6 mt-5 mt-lg-0">-->
<!--              <div class="count-box">-->
<!--                <i class="icofont-award"></i>-->
<!--                <span data-toggle="counter-up">150</span>-->
<!--                <p>Awards</p>-->
<!--              </div>-->
<!--            </div>-->

<!--          </div>-->

<!--        </div>-->
<!--      </section>&lt;!&ndash; End Counts Section &ndash;&gt;-->

      <!-- ======= Services Section ======= -->
      <section id="doctortype" class="doctortype">
        <div class="container">
          <div class="section-title">
            <h2>Type Of Doctors</h2>
          </div>

          <div class="row">
            <div class="col-lg-4 col-md-6 d-flex mt-4 justify-content-center" v-for="doctortype in this.getdoctortype" :key="doctortype.id">
              <div class="icon-box" style="alignment: center;">
                <img class="imgae" :src="getImageUrl(doctortype)" style="alignment: center">
                <h3 class="heading text-center">
                  <router-link :to="{name: 'generalUserdoctorsList', query: { doctortype_id: doctortype.id }}">{{doctortype.name}}</router-link>
                </h3>
              </div>
            </div>

          </div>

        </div>
      </section>
      <!-- End Services Section -->


<!--      &lt;!&ndash; ======= Departments Section ======= &ndash;&gt;-->
<!--      <section id="departments" class="departments">-->
<!--        <div class="container">-->

<!--          <div class="section-title">-->
<!--            <h2>Departments</h2>-->
<!--            <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint-->
<!--              consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat-->
<!--              sit-->
<!--              in iste officiis commodi quidem hic quas.</p>-->
<!--          </div>-->

<!--          <div class="row">-->
<!--            <div class="col-lg-3">-->
<!--              <ul class="nav nav-tabs flex-column">-->
<!--                <li class="nav-item">-->
<!--                  <a class="nav-link active show" data-toggle="tab" href="#tab-1">Cardiology</a>-->
<!--                </li>-->
<!--                <li class="nav-item">-->
<!--                  <a class="nav-link" data-toggle="tab" href="#tab-2">Neurology</a>-->
<!--                </li>-->
<!--                <li class="nav-item">-->
<!--                  <a class="nav-link" data-toggle="tab" href="#tab-3">Hepatology</a>-->
<!--                </li>-->
<!--                <li class="nav-item">-->
<!--                  <a class="nav-link" data-toggle="tab" href="#tab-4">Pediatrics</a>-->
<!--                </li>-->
<!--                <li class="nav-item">-->
<!--                  <a class="nav-link" data-toggle="tab" href="#tab-5">Eye Care</a>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--            <div class="col-lg-9 mt-4 mt-lg-0">-->
<!--              <div class="tab-content">-->
<!--                <div class="tab-pane active show" id="tab-1">-->
<!--                  <div class="row">-->
<!--                    <div class="col-lg-8 details order-2 order-lg-1">-->
<!--                      <h3>Cardiology</h3>-->
<!--                      <p class="font-italic">Qui laudantium consequatur laborum sit qui ad sapiente dila parde sonata-->
<!--                        raqer a videna mareta paulona marka</p>-->
<!--                      <p>Et nobis maiores eius. Voluptatibus ut enim blanditiis atque harum sint. Laborum eos ipsum ipsa-->
<!--                        odit magni. Incidunt hic ut molestiae aut qui. Est repellat minima eveniet eius et quis magni-->
<!--                        nihil. Consequatur dolorem quaerat quos qui similique accusamus nostrum rem vero</p>-->
<!--                    </div>-->
<!--                    <div class="col-lg-4 text-center order-1 order-lg-2">-->
<!--                      <img src="assets/img/departments-1.jpg" alt="" class="img-fluid">-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="tab-pane" id="tab-2">-->
<!--                  <div class="row">-->
<!--                    <div class="col-lg-8 details order-2 order-lg-1">-->
<!--                      <h3>Et blanditiis nemo veritatis excepturi</h3>-->
<!--                      <p class="font-italic">Qui laudantium consequatur laborum sit qui ad sapiente dila parde sonata-->
<!--                        raqer a videna mareta paulona marka</p>-->
<!--                      <p>Ea ipsum voluptatem consequatur quis est. Illum error ullam omnis quia et reiciendis sunt sunt-->
<!--                        est. Non aliquid repellendus itaque accusamus eius et velit ipsa voluptates. Optio nesciunt-->
<!--                        eaque-->
<!--                        beatae accusamus lerode pakto madirna desera vafle de nideran pal</p>-->
<!--                    </div>-->
<!--                    <div class="col-lg-4 text-center order-1 order-lg-2">-->
<!--                      <img src="assets/img/departments-2.jpg" alt="" class="img-fluid">-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="tab-pane" id="tab-3">-->
<!--                  <div class="row">-->
<!--                    <div class="col-lg-8 details order-2 order-lg-1">-->
<!--                      <h3>Impedit facilis occaecati odio neque aperiam sit</h3>-->
<!--                      <p class="font-italic">Eos voluptatibus quo. Odio similique illum id quidem non enim fuga. Qui-->
<!--                        natus-->
<!--                        non sunt dicta dolor et. In asperiores velit quaerat perferendis aut</p>-->
<!--                      <p>Iure officiis odit rerum. Harum sequi eum illum corrupti culpa veritatis quisquam. Neque-->
<!--                        necessitatibus illo rerum eum ut. Commodi ipsam minima molestiae sed laboriosam a iste odio.-->
<!--                        Earum-->
<!--                        odit nesciunt fugiat sit ullam. Soluta et harum voluptatem optio quae</p>-->
<!--                    </div>-->
<!--                    <div class="col-lg-4 text-center order-1 order-lg-2">-->
<!--                      <img src="assets/img/departments-3.jpg" alt="" class="img-fluid">-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="tab-pane" id="tab-4">-->
<!--                  <div class="row">-->
<!--                    <div class="col-lg-8 details order-2 order-lg-1">-->
<!--                      <h3>Fuga dolores inventore laboriosam ut est accusamus laboriosam dolore</h3>-->
<!--                      <p class="font-italic">Totam aperiam accusamus. Repellat consequuntur iure voluptas iure porro-->
<!--                        quis-->
<!--                        delectus</p>-->
<!--                      <p>Eaque consequuntur consequuntur libero expedita in voluptas. Nostrum ipsam necessitatibus-->
<!--                        aliquam-->
<!--                        fugiat debitis quis velit. Eum ex maxime error in consequatur corporis atque. Eligendi-->
<!--                        asperiores-->
<!--                        sed qui veritatis aperiam quia a laborum inventore</p>-->
<!--                    </div>-->
<!--                    <div class="col-lg-4 text-center order-1 order-lg-2">-->
<!--                      <img src="assets/img/departments-4.jpg" alt="" class="img-fluid">-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="tab-pane" id="tab-5">-->
<!--                  <div class="row">-->
<!--                    <div class="col-lg-8 details order-2 order-lg-1">-->
<!--                      <h3>Est eveniet ipsam sindera pad rone matrelat sando reda</h3>-->
<!--                      <p class="font-italic">Omnis blanditiis saepe eos autem qui sunt debitis porro quia.</p>-->
<!--                      <p>Exercitationem nostrum omnis. Ut reiciendis repudiandae minus. Omnis recusandae ut non quam ut-->
<!--                        quod eius qui. Ipsum quia odit vero atque qui quibusdam amet. Occaecati sed est sint aut vitae-->
<!--                        molestiae voluptate vel</p>-->
<!--                    </div>-->
<!--                    <div class="col-lg-4 text-center order-1 order-lg-2">-->
<!--                      <img src="assets/img/departments-5.jpg" alt="" class="img-fluid">-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->
<!--      </section>-->
<!--      &lt;!&ndash; End Departments Section &ndash;&gt;-->

<!--      &lt;!&ndash; ======= Doctors Section ======= &ndash;&gt;-->
<!--      &lt;!&ndash; End Doctors Section &ndash;&gt;-->

<!--      &lt;!&ndash; ======= Frequently Asked Questions Section ======= &ndash;&gt;-->
<!--      <section id="faq" class="faq section-bg">-->
<!--        <div class="container">-->

<!--          <div class="section-title">-->
<!--            <h2>Frequently Asked Questions</h2>-->
<!--            <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint-->
<!--              consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat-->
<!--              sit-->
<!--              in iste officiis commodi quidem hic quas.</p>-->
<!--          </div>-->

<!--          <div class="faq-list">-->
<!--            <ul>-->
<!--              <li data-aos="fade-up">-->
<!--                <i class="bx bx-help-circle icon-help"></i> <a data-toggle="collapse" class="collapse"-->
<!--                                                               href="#faq-list-1">Non-->
<!--                consectetur a erat nam at lectus urna duis? <i class="bx bx-chevron-down icon-show"></i><i-->
<!--                    class="bx bx-chevron-up icon-close"></i></a>-->
<!--                <div id="faq-list-1" class="collapse show" data-parent=".faq-list">-->
<!--                  <p>-->
<!--                    Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur-->
<!--                    gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non.-->
<!--                  </p>-->
<!--                </div>-->
<!--              </li>-->

<!--              <li data-aos="fade-up" data-aos-delay="100">-->
<!--                <i class="bx bx-help-circle icon-help"></i> <a data-toggle="collapse" href="#faq-list-2"-->
<!--                                                               class="collapsed">Feugiat scelerisque varius morbi enim-->
<!--                nunc? <i class="bx bx-chevron-down icon-show"></i><i class="bx bx-chevron-up icon-close"></i></a>-->
<!--                <div id="faq-list-2" class="collapse" data-parent=".faq-list">-->
<!--                  <p>-->
<!--                    Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi. Id interdum velit laoreet id-->
<!--                    donec ultrices. Fringilla phasellus faucibus scelerisque eleifend donec pretium. Est pellentesque-->
<!--                    elit-->
<!--                    ullamcorper dignissim. Mauris ultrices eros in cursus turpis massa tincidunt dui.-->
<!--                  </p>-->
<!--                </div>-->
<!--              </li>-->

<!--              <li data-aos="fade-up" data-aos-delay="200">-->
<!--                <i class="bx bx-help-circle icon-help"></i> <a data-toggle="collapse" href="#faq-list-3"-->
<!--                                                               class="collapsed">Dolor sit amet consectetur adipiscing-->
<!--                elit? <i class="bx bx-chevron-down icon-show"></i><i class="bx bx-chevron-up icon-close"></i></a>-->
<!--                <div id="faq-list-3" class="collapse" data-parent=".faq-list">-->
<!--                  <p>-->
<!--                    Eleifend mi in nulla posuere sollicitudin aliquam ultrices sagittis orci. Faucibus pulvinar-->
<!--                    elementum-->
<!--                    integer enim. Sem nulla pharetra diam sit amet nisl suscipit. Rutrum tellus pellentesque eu-->
<!--                    tincidunt.-->
<!--                    Lectus urna duis convallis convallis tellus. Urna molestie at elementum eu facilisis sed odio morbi-->
<!--                    quis-->
<!--                  </p>-->
<!--                </div>-->
<!--              </li>-->

<!--              <li data-aos="fade-up" data-aos-delay="300">-->
<!--                <i class="bx bx-help-circle icon-help"></i> <a data-toggle="collapse" href="#faq-list-4"-->
<!--                                                               class="collapsed">Tempus quam pellentesque nec nam-->
<!--                aliquam-->
<!--                sem et tortor consequat? <i class="bx bx-chevron-down icon-show"></i><i-->
<!--                    class="bx bx-chevron-up icon-close"></i></a>-->
<!--                <div id="faq-list-4" class="collapse" data-parent=".faq-list">-->
<!--                  <p>-->
<!--                    Molestie a iaculis at erat pellentesque adipiscing commodo. Dignissim suspendisse in est ante in.-->
<!--                    Nunc-->
<!--                    vel risus commodo viverra maecenas accumsan. Sit amet nisl suscipit adipiscing bibendum est. Purus-->
<!--                    gravida quis blandit turpis cursus in.-->
<!--                  </p>-->
<!--                </div>-->
<!--              </li>-->

<!--              <li data-aos="fade-up" data-aos-delay="400">-->
<!--                <i class="bx bx-help-circle icon-help"></i> <a data-toggle="collapse" href="#faq-list-5"-->
<!--                                                               class="collapsed">Tortor vitae purus faucibus ornare.-->
<!--                Varius vel pharetra vel turpis nunc eget lorem dolor? <i class="bx bx-chevron-down icon-show"></i><i-->
<!--                    class="bx bx-chevron-up icon-close"></i></a>-->
<!--                <div id="faq-list-5" class="collapse" data-parent=".faq-list">-->
<!--                  <p>-->
<!--                    Laoreet sit amet cursus sit amet dictum sit amet justo. Mauris vitae ultricies leo integer malesuada-->
<!--                    nunc vel. Tincidunt eget nullam non nisi est sit amet. Turpis nunc eget lorem dolor sed. Ut-->
<!--                    venenatis-->
<!--                    tellus in metus vulputate eu scelerisque.-->
<!--                  </p>-->
<!--                </div>-->
<!--              </li>-->

<!--            </ul>-->
<!--          </div>-->

<!--        </div>-->
<!--      </section>-->
<!--      &lt;!&ndash; End Frequently Asked Questions Section &ndash;&gt;-->

<!--      &lt;!&ndash; ======= Contact Section ======= &ndash;&gt;-->
<!--      <section id="contact" class="contact">-->
<!--        <div class="container">-->

<!--          <div class="section-title">-->
<!--            <h2>Contact</h2>-->
<!--            <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint-->
<!--              consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat-->
<!--              sit-->
<!--              in iste officiis commodi quidem hic quas.</p>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="container">-->
<!--          <div class="row mt-5">-->

<!--            <div class="col-lg-4">-->
<!--              <div class="info">-->
<!--                <div class="address">-->
<!--                  <i class="icofont-google-map"></i>-->
<!--                  <h4>Location:</h4>-->
<!--                  <p>A108 Adam Street, New York, NY 535022</p>-->
<!--                </div>-->

<!--                <div class="email">-->
<!--                  <i class="icofont-envelope"></i>-->
<!--                  <h4>Email:</h4>-->
<!--                  <p>info@example.com</p>-->
<!--                </div>-->

<!--                <div class="phone">-->
<!--                  <i class="icofont-phone"></i>-->
<!--                  <h4>Call:</h4>-->
<!--                  <p>+1 5589 55488 55s</p>-->
<!--                </div>-->

<!--              </div>-->

<!--            </div>-->

<!--            <div class="col-lg-8 mt-5 mt-lg-0">-->

<!--              <form  method="post" role="form" class="php-email-form">-->

<!--                <div class="form-group">-->
<!--                  <input type="text" class="form-control" name="subject" id="subject" placeholder="Subject"-->
<!--                         data-rule="minlen:4" data-msg="Please enter at least 8 chars of subject"/>-->
<!--                  <div class="validate"></div>-->
<!--                </div>-->
<!--                <div class="form-group">-->
<!--                <textarea class="form-control" name="message" rows="5" data-rule="required"-->
<!--                          data-msg="Please write something for us" placeholder="Message"></textarea>-->
<!--                  <div class="validate"></div>-->
<!--                </div>-->
<!--                <div class="mb-3">-->
<!--                  <div class="loading">Loading</div>-->
<!--                  <div class="error-message"></div>-->
<!--                  <div class="sent-message">Your message has been sent. Thank you!</div>-->
<!--                </div>-->
<!--                <div class="text-center">-->
<!--                  <button type="submit">Send Message</button>-->
<!--                </div>-->
<!--              </form>-->

<!--            </div>-->

<!--          </div>-->

<!--        </div>-->
<!--      </section>-->
<!--      &lt;!&ndash; End Contact Section &ndash;&gt;-->

    </main><!-- End #main -->

  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: "Home",
  computed:{
    ...mapGetters('generalUserDoctor',['getdoctortype']),
  },
  methods:{
    getImageUrl(doctortype){
      return `${process.env.VUE_APP_BACKEND_URL}/${doctortype.monogram}`;
    },
  },
}
</script>

<style scoped>
 .imgae{
   height: 125px;
   width: 125px;
   margin: 0 auto;
   border-radius: 5px;
   transition: all .3s ease-out 0s;
   display: flex;
   align-items: center;
   justify-content: center;
   margin-bottom: 20px;
   transform-style: preserve-3d;
 }
 .icon-box .icon {

 }
 .heading{
   alignment: center;
 }


</style>
